import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  deleteModal?: any;
  dialogModal?: any;
}

const initialState: UIState = {
  deleteModal: undefined,
  dialogModal: undefined,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setDeleteModal: (state, action: PayloadAction<any | undefined>) => {
      state.deleteModal = action.payload;
    },
  },
});

export const { setDeleteModal } = uiSlice.actions;
export default uiSlice.reducer;
